import React from 'react';
import Router from './Router';
import './App.css';
import GlobalModule from './components/Modules/GlobalModule';

const App = () => {
  return (
    <GlobalModule>
      <Router />
    </GlobalModule>
  )
}

export default App